<template>
  <li
    class="flex items-start gap-4 border-b border-gray-200 py-4 last:border-b-0"
  >
    <SFBasketCardSoldOutTitle
      v-if="isSoldOut"
      class="hidden group-first:flex"
    />
    <SFBasketCardImage
      :basket-item="item"
      hide-wishlist-toggle
      width="128"
      height="128"
      class="group-first:hidden"
      :is-sold-out="isSoldOut"
    />
    <div class="w-[164px] overflow-hidden" :class="{ 'opacity-25': isSoldOut }">
      <SFProductPrice
        :lowest-prior-price="item?.lowestPriorPrice"
        :price="item.price.unit"
        :promotion="item.promotion"
        :show-badges="true"
        :absolute-discount-label="false"
        :discount-label-right="false"
        data-testid="basket-card-prices"
        size="lg"
        type="medium"
      />
      <div class="flex items-center gap-2 truncate text-gray-500">
        {{ brand }}
      </div>
      <div class="w-full truncate">{{ name }}</div>
      <SFBasketCardDetails :item="item" class="mt-3" is-quantity-shown />
    </div>
    <div class="pr-3">
      <button class="focus:outline-none" type="button" @click="emit('delete')">
        <IconTrash width="24" height="24" />
      </button>
    </div>
  </li>
</template>

<script setup lang="ts">
import type { BasketItem } from '@scayle/storefront-nuxt'
import { computed } from 'vue'
import { useProductBaseInfo } from '~/composables'
import SFProductPrice from '~/components/product/SFProductPrice.vue'
import SFBasketCardDetails from '~/components/basket/SFBasketCardDetails.vue'
import SFBasketCardSoldOutTitle from '~/components/basket/SFBasketCardSoldOutTitle.vue'
import SFBasketCardImage from '~/components/basket/SFBasketCardImage.vue'

const { item } = defineProps<{
  item: BasketItem
}>()

const emit = defineEmits<{
  delete: []
}>()

const { brand, name } = useProductBaseInfo(item.product)

const isSoldOut = computed(() => item.status !== 'available')
</script>

<style scoped>
picture {
  width: fit-content;
}
</style>
